import { render, staticRenderFns } from "./pageNotFound.vue?vue&type=template&id=bddc1252&scoped=true"
import script from "./pageNotFound.vue?vue&type=script&lang=js"
export * from "./pageNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddc1252",
  null
  
)

export default component.exports